import { TargetingMediaTypeEnum } from '../../../Discover/Targeting/enums/targeting-media-type.enum';

export enum ProductTypesEnum {
    blog = 'BLOG',
    contentCreationService = 'CONTENT_CREATION_SERVICE',
    foreignBureau = 'FOREIGN_BUREAU',
    mediaCompany = 'MEDIA_COMPANY', // @TODO was previously mapped to Media Group, consider removing
    newsAgency = 'NEWS_AGENCY',
    newsService = 'NEWS_SERVICE',
    newspaper = 'NEWSPAPER',
    podcast = 'PODCAST',
    productionCompany = 'PRODUCTION_COMPANY',
    programme = 'PROGRAMME',
    publication = 'PUBLICATION',
    regionalNewsTeam = 'REGIONAL_OFFICE',
    section = 'SECTION',
    station = 'STATION',
    videoSharingSite = 'VIDEO_SHARING_SITE'
}

/** eslint-disable @stylistic/indent */
export const mediaProductTypeMap = new Map<TargetingMediaTypeEnum, ProductTypesEnum[]>([
    [TargetingMediaTypeEnum.ONLINE, [
        ProductTypesEnum.blog,
        ProductTypesEnum.contentCreationService,
        ProductTypesEnum.foreignBureau,
        ProductTypesEnum.newsAgency,
        ProductTypesEnum.newspaper,
        ProductTypesEnum.newsService,
        ProductTypesEnum.podcast,
        ProductTypesEnum.publication,
        ProductTypesEnum.regionalNewsTeam,
        ProductTypesEnum.section,
        ProductTypesEnum.videoSharingSite
    ]],
    [TargetingMediaTypeEnum.PRINT, [
        ProductTypesEnum.contentCreationService,
        ProductTypesEnum.foreignBureau,
        ProductTypesEnum.newspaper,
        ProductTypesEnum.publication,
        ProductTypesEnum.regionalNewsTeam,
        ProductTypesEnum.section
    ]],
    [TargetingMediaTypeEnum.RADIO, [
        ProductTypesEnum.foreignBureau,
        ProductTypesEnum.productionCompany,
        ProductTypesEnum.programme,
        ProductTypesEnum.regionalNewsTeam,
        ProductTypesEnum.station
    ]],
    [TargetingMediaTypeEnum.TELEVISION, [
        ProductTypesEnum.foreignBureau,
        ProductTypesEnum.productionCompany,
        ProductTypesEnum.programme,
        ProductTypesEnum.regionalNewsTeam,
        ProductTypesEnum.station
    ]],
]);
